webpackJsonp([126093192170660],{

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(19);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _publication = __webpack_require__(27);
	
	var _publication2 = _interopRequireDefault(_publication);
	
	var _videoframe = __webpack_require__(28);
	
	var _videoframe2 = _interopRequireDefault(_videoframe);
	
	var _extLink = __webpack_require__(24);
	
	var _extLink2 = _interopRequireDefault(_extLink);
	
	var _ballcamera = __webpack_require__(114);
	
	var _ballcamera2 = _interopRequireDefault(_ballcamera);
	
	var _pfeil_throwablePanoramicBallCamera_demoAbstract = __webpack_require__(292);
	
	var _pfeil_throwablePanoramicBallCamera_demoAbstract2 = _interopRequireDefault(_pfeil_throwablePanoramicBallCamera_demoAbstract);
	
	var _pfeil_throwablePanoramicBallCamera_demoTalkSlides = __webpack_require__(293);
	
	var _pfeil_throwablePanoramicBallCamera_demoTalkSlides2 = _interopRequireDefault(_pfeil_throwablePanoramicBallCamera_demoTalkSlides);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var demoAbstractBibTexStr = "@inproceedings{Pfeil:2011:TPB:2073370.2073373,\n  author = {Pfeil, Jonas and Hildebrand, Kristian and Gremzow, Carsten and Bickel, Bernd and Alexa, Marc},\n  title = {Throwable Panoramic Ball Camera},\n  booktitle = {SIGGRAPH Asia 2011 Emerging Technologies},\n  series = {SA '11},\n  year = {2011},\n  isbn = {978-1-4503-1136-6},\n  location = {Hong Kong, China},\n  pages = {4:1--4:1},\n  articleno = {4},\n  numpages = {1},\n  url = {http://doi.acm.org/10.1145/2073370.2073373},\n  doi = {10.1145/2073370.2073373},\n  acmid = {2073373},\n  publisher = {ACM},\n  address = {New York, NY, USA},\n}";
	
	exports.default = function () {
	  return _react2.default.createElement(
	    "div",
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      null,
	      _react2.default.createElement(
	        "title",
	        null,
	        "Throwable Panoramic Ball Camera"
	      ),
	      _react2.default.createElement("meta", {
	        name: "description",
	        content: "The camera is thrown into the air and captures an image at the highest point of flight - when it is hardly moving. The camera takes full spherical panoramas, requires no preparation and images are taken instantaneously. It can capture scenes with many moving objects without producing ghosting artifacts and creates unique images."
	      })
	    ),
	    _react2.default.createElement(
	      "h1",
	      null,
	      _react2.default.createElement(
	        "span",
	        { style: { position: "absolute", fontSize: "28px", top: "9px" } },
	        "Throwable Panoramic"
	      ),
	      _react2.default.createElement(
	        "span",
	        { style: { position: "absolute", top: "32px" } },
	        "Ball Camera"
	      )
	    ),
	    _react2.default.createElement(_videoframe2.default, {
	      youtubeId: "Th5zlUe6gOE",
	      img: _ballcamera2.default,
	      imgAltText: "Throwable Panoramic Ball Camera"
	    }),
	    _react2.default.createElement(
	      "div",
	      { id: "description" },
	      _react2.default.createElement(
	        "p",
	        null,
	        "This was my thesis project at the",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "http://www.cg.tu-berlin.de/" },
	          "Computer Graphics Group, TU Berlin"
	        ),
	        ". Also published as a demo at the SIGGRAPH Asia 2011. The video went viral (3.5M views) and generated a lot of media coverage. For example",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "https://www.technologyreview.com/s/426335/eye-ball/" },
	          "here"
	        ),
	        ",",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "https://www.wired.com/2011/10/throwable-panoramic-ball-camera-shoots-360-degree-panoramas/" },
	          "here"
	        ),
	        " ",
	        "and",
	        " ",
	        _react2.default.createElement(
	          _extLink2.default,
	          { to: "https://www.popphoto.com/gear/2011/10/new-gear-throwable-panoramic-ball-camera" },
	          "here"
	        ),
	        "."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "The Throwable Panoramic Ball Camera is a high resolution 360 camera that can be thrown into the air to capture a panoramic photo. It can also be triggered via cable when mounted on a tripod. As this was my thesis project I developed the whole camera (software, hardware and mechanics)."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "[Update]",
	        " ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/ballcamera/chancellor-merkel/" },
	          "German Chancellor Dr. Merkel Checks out the Throwable Panoramic Ball Camera"
	        )
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "[Update] Now available under the name ",
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: "/panono/" },
	          "Panono"
	        )
	      ),
	      _react2.default.createElement(_publication2.default, {
	        type: "Demo",
	        title: "Throwable Panoramic Ball Camera",
	        bookTitle: "SIGGRAPH Asia 2011 Emerging Technologies",
	        authors: "Jonas Pfeil, Kristian Hildebrand, Carsten Gremzow, Bernd Bickel and Marc Alexa",
	        bibTex: demoAbstractBibTexStr,
	        paperURL: _pfeil_throwablePanoramicBallCamera_demoAbstract2.default,
	        paperLinkText: "Demo Abstract",
	        talkSlidesURL: _pfeil_throwablePanoramicBallCamera_demoTalkSlides2.default,
	        talkSlidesLinkText: "Talk Slides"
	      }),
	      _react2.default.createElement(_publication2.default, {
	        type: "Patent",
	        title: "Camera system for recording images, and associated method",
	        bookTitle: "US Patent, issued 2016",
	        authors: "Jonas Pfeil",
	        paperURL: "http://patft.uspto.gov/netacgi/nph-Parser?Sect2=PTO1&Sect2=HITOFF&p=1&u=/netahtml/PTO/search-bool.html&r=1&f=G&l=50&d=PALL&RefSrch=yes&Query=PN/9531951",
	        paperLinkText: "US9531951 B2"
	      }),
	      _react2.default.createElement(_publication2.default, {
	        type: "Diploma Thesis",
	        title: "Throwable Camera Array for Capturing Spherical Panoramas",
	        bookTitle: "Thesis, 2010",
	        authors: "Jonas Pfeil (Advisors: Marc Alexa, Carsten Gremzow)"
	      }),
	      _react2.default.createElement(
	        "h2",
	        null,
	        "Abstract"
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Panoramic photography creates fascinating images. Very wide angle images are closer to the human field of view than conventional pictures. If seen through a panoramic viewer they let us experience a location as if we were there. Panoramic image stitching can create panoramas from pictures taken one after another. Unfortunately, acquiring the images takes a lot of time and moving objects may cause ghosting. It is also difficult to obtain a full spherical panorama, because the downward picture cannot be captured while the camera is mounted on the tripod."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "In this work, we present a throwable panoramic camera that solves these problems. The camera is thrown into the air and captures an image at the highest point of flight - when it is hardly moving. The camera takes full spherical panoramas, requires no preparation and images are taken instantaneously. It can capture scenes with many moving objects without producing ghosting artifacts and creates unique images."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "Our camera uses 36 fixed-focus 2 megapixel mobile phone camera modules. The camera modules are mounted in a robust, 3D-printed, ball-shaped enclosure that is padded with foam and handles just like a ball. Our camera contains an accelerometer which we use to measure launch acceleration. Integration lets us predict rise time to the highest point, where we trigger the exposure. After catching the ball camera, pictures are downloaded in seconds using USB and automatically shown in our spherical panoramic viewer. This lets users interactively explore a full representation of the captured environment."
	      ),
	      _react2.default.createElement(
	        "p",
	        null,
	        "We used the camera to capture full spherical panoramas at scenic spots, in a crowded city square and in the middle of a group of people taking turns in throwing the camera. Above all we found that it is a very enjoyable, playful way to take pictures."
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { id: "facts" },
	      _react2.default.createElement(
	        "dl",
	        null,
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Hardware"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "ATtiny24, AVR UC3B, STM VS6724, [\u2026]"
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Software"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "C, C++, Qt, OpenCV"
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "People"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Jonas Pfeil"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Kristian Hildebrand"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Carsten Gremzow"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Bernd Bickel"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Marc Alexa"
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Advisors"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          _react2.default.createElement(
	            _extLink2.default,
	            { to: "https://www.cg.tu-berlin.de/team/prof-dr-marc-alexa/" },
	            "Prof. Marc Alexa"
	          )
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "Carsten Gremzow"
	        ),
	        _react2.default.createElement(
	          "dt",
	          null,
	          "Year"
	        ),
	        _react2.default.createElement(
	          "dd",
	          null,
	          "2010"
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2011_pfeil_throwable-panoramic-ball-camera_demo-abstract.40de8b8d.pdf";

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2011_pfeil_throwable-panoramic-ball-camera_demo-talk-slides.d6511195.pdf";

/***/ }),

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/ballcamera.5d7424c6.jpg";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ballcamera-jsx-16953aa4192338c0bf74.js